// data-proto="agent" lets the editor agent strip its own tag before it emits the edited HTML.
export const buildVisualSrcdoc = (html: string, agentUrl: string): string => {
  const scriptTag = `<script data-proto="agent" src="${agentUrl}"></script>`;
  return html.includes("</body>")
    ? html.replace("</body>", scriptTag + "</body>")
    : html + scriptTag;
};
